import { gql } from '@apollo/client';

export const LIST_DSP_BILLING_CADENCE_WHITELIST = gql`
  query ListDspBillingCadenceWhitelist(
    $dspId: Long
    $status: String
    $pageRequest: PageRequestTypeInput
  ) {
    listDspBillingCadenceWhitelist(dspId: $dspId, status: $status, pageRequest: $pageRequest) {
      content {
        id
        dspId
        status
        effectiveFromLA
        billingSummaryTimeLA
        removedAtLA
        createdBy
        removedBy
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const GET_ACTIVE_DSP_BILLING_CADENCE_WHITELIST = gql`
  query GetActiveDspBillingCadenceWhitelist($dspId: Long!) {
    getActiveDspBillingCadenceWhitelist(dspId: $dspId) {
      id
      dspId
      status
      effectiveFromLA
      billingSummaryTimeLA
      removedAtLA
    }
  }
`;

export const ADD_DSP_BILLING_CADENCE_WHITELIST = gql`
  mutation AddDspBillingCadenceWhitelist($input: AddDspBillingCadenceWhitelistInput!) {
    addDspBillingCadenceWhitelist(input: $input)
  }
`;

export const REMOVE_DSP_BILLING_CADENCE_WHITELIST = gql`
  mutation RemoveDspBillingCadenceWhitelist($dspId: Long!) {
    removeDspBillingCadenceWhitelist(dspId: $dspId)
  }
`;
